/* ÉPRIS Notify-Me (Wishlist + ausverkaufte Produktseiten)
   07.09.2026: Eintrag geht an Klaviyo Back in Stock (Worker /bis), CartBite nicht mehr.
   Fallback bleibt das Shopify-Kontaktformular. Original: epris-wishlist-notify.ORIGINAL.js */
(function () {
  "use strict";

  function init() {
    const modal = document.getElementById("epris-notify-modal");
    if (!modal) return;

    const intro = modal.querySelector("[data-notify-intro]");
    const form = modal.querySelector("[data-notify-form]");
    const emailInput = modal.querySelector("[data-notify-email]");
    const submitBtn = modal.querySelector("[data-notify-submit]");
    const errorEl = modal.querySelector("[data-notify-error]");
    const formState = modal.querySelector("[data-notify-form-state]");
    const successState = modal.querySelector("[data-notify-success-state]");
    const successText = modal.querySelector("[data-notify-success-text]");
    const T = window.EPRIS_TRANS || {};
    let currentProduct = null;

    function open(product) {
      currentProduct = product || {};
      formState.hidden = false;
      successState.hidden = true;
      errorEl.hidden = true;
      errorEl.textContent = "";
      emailInput.value = "";
      submitBtn.disabled = false;
      submitBtn.textContent = T.wishlistNotifySubmit || "Benachrichtige mich.";
      const introTpl = T.wishlistNotifyIntro || "Wir benachrichtigen dich sobald {{ product }} wieder auf Lager ist.";
      const productName = currentProduct.title || "der Duft";
      intro.innerHTML = introTpl.replace("{{ product }}", "<strong>" + escapeHtml(productName) + "</strong>");
      modal.removeAttribute("hidden");
      modal.setAttribute("aria-hidden", "false");
      requestAnimationFrame(() => {
        modal.classList.add("is-visible");
        emailInput.focus();
      });
    }

    function close() {
      modal.classList.remove("is-visible");
      modal.setAttribute("aria-hidden", "true");
      setTimeout(() => {
        if (!modal.classList.contains("is-visible")) modal.setAttribute("hidden", "");
      }, 320);
    }

    // Der Seitenwechsel-Loader (epris-loader.js) fängt Klicks auf Links in der Capture-Phase ab und springt nach 180 ms zum Link-Ziel.
    // Der Wishlist-Button „Benachrichtigen“ liegt innerhalb des Produkt-Links – deshalb hier (Capture am window, läuft davor) als
    // verarbeitet markieren, sonst überschreibt der Loader unseren Sprung zur Produktseite mit ?bis=1.
    window.addEventListener("click", (e) => {
      if (e.target && e.target.closest && e.target.closest("[data-wd-notify], [data-wp-notify]")) e.preventDefault();
    }, true);
    document.addEventListener("epris:notify:open", (e) => {
      const product = e.detail && e.detail.product;
      // Wishlist/Drawer (07.09.2026): nicht das eigene Fenster, sondern zur Produktseite → dort öffnet sich Klaviyos Back-in-Stock-Formular
      // (nur die Produktseite kennt Produkt und Variante). Auf der Produktseite selbst bleibt dieses Fenster der Fallback.
      // Immer die kanonische Adresse /products/<handle> nehmen: die Wishlist speichert oft die Kollektions-URL
      // (/collections/…/products/x), und deren Weiterleitung verliert den ?bis=1-Parameter.
      const handle = product && (product.handle || (product.url ? String(product.url).split("?")[0].replace(/^https?:\/\/[^/]+/, "").replace(/^.*\/products\//, "") : ""));
      const path = handle ? "/products/" + handle : "";
      const here = location.pathname.replace(/^.*\/products\//, "/products/");
      if (path && here !== path) {
        setTimeout(() => {   // nach dem Klick-Event; mit dem Seiten-Loader als Übergang, falls vorhanden
          try { if (window.eprisLoader) window.eprisLoader.show({ withLoader: false }); } catch (err) {}
          location.href = path + "?bis=1";
        }, 0);
        return;
      }
      // Schon auf der Produktseite: denselben Weg wie der PDP-Button nehmen (Klaviyo-Formular). fallback=true kommt vom
      // PDP-Button selbst, wenn Klaviyo nicht öffnet – dann hier das eigene Fenster, sonst Endlosschleife.
      // 02.10.2026: Ist Chatarmins WhatsApp-Widget gerendert, dessen Button nehmen (Back in Stock nur noch per WhatsApp).
      const caBtn = Array.from(document.querySelectorAll("button[class*='wa-']")).find((n) => /(^|\s)wa-/.test(n.className) && (n.offsetWidth || n.offsetHeight));
      const pdpButton = caBtn || document.querySelector(".epris-bis-button");
      if (pdpButton && !(e.detail && e.detail.fallback)) {
        setTimeout(() => {   // außerhalb des laufenden Klick-Events, sonst navigiert der Wishlist-Link trotz preventDefault
          const closeDrawer = document.querySelector("#epris-wishlist-drawer [data-wd-close]");
          if (closeDrawer) closeDrawer.click();
          pdpButton.click();
        }, 0);
        return;
      }
      open(product);
    });
    modal.addEventListener("click", (e) => {
      if (e.target.closest("[data-notify-close]")) close();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.classList.contains("is-visible")) close();
    });

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const email = (emailInput.value || "").trim();
      if (!email) return;
      submitBtn.disabled = true;
      submitBtn.textContent = T.wishlistNotifySubmitting || "Wird gespeichert …";
      errorEl.hidden = true;
      try {
        const ok = (await submitToKlaviyo(email, currentProduct)) || (await submitContactFallback(email, currentProduct));
        if (!ok) throw new Error("notify failed");
        formState.hidden = true;
        successState.hidden = false;
        const tpl = T.wishlistNotifySuccessText || "Wir melden uns sobald {{ product }} wieder verfügbar ist.";
        successText.innerHTML = tpl.replace("{{ product }}", "<strong>" + escapeHtml(currentProduct.title || "der Duft") + "</strong>");
        setTimeout(close, 3500);
      } catch (err) {
        console.error("[notify-me]", err);
        errorEl.textContent = T.wishlistNotifyError || "Etwas ist schiefgelaufen.";
        errorEl.hidden = false;
        submitBtn.disabled = false;
        submitBtn.textContent = T.wishlistNotifySubmit || "Benachrichtige mich.";
      }
    });
  }

  // Klaviyo Back in Stock über den ÉPRIS-Worker (legt das Abo an, Klaviyo-Flow benachrichtigt bei Wiederverfügbarkeit)
  async function submitToKlaviyo(email, product) {
    try {
      const vid = parseInt(product.variant_id, 10);
      if (!vid) return false;
      const name = (product.title || "").replace(/\s*-?\s*N°.*$/, "");
      const u = "https://epris-order-tagger.cdb-tech.workers.dev/bis?src=pdp&fmt=json"
        + "&e=" + encodeURIComponent(email)
        + "&v=" + vid
        + "&pid=" + encodeURIComponent(product.id || "")
        + "&n=" + encodeURIComponent(name);
      const r = await fetch(u, { method: "GET", mode: "cors" });
      const j = await r.json().catch(() => ({}));
      return !!(r.ok && j.ok);
    } catch (e) {
      console.warn("[notify-me klaviyo]", e);
      return false;
    }
  }

  // Letzter Fallback: Shopify-Kontaktformular (landet als Mail im Support-Postfach)
  async function submitContactFallback(email, product) {
    const fd = new FormData();
    fd.append("form_type", "contact");
    fd.append("utf8", "✓");
    fd.append("contact[email]", email);
    fd.append("contact[name]", "Restock Request (Wishlist Fallback)");
    fd.append("contact[subject]", "[RESTOCK] " + (product.title || "Produkt"));
    fd.append("contact[body]", [
      "🔔 RESTOCK NOTIFICATION REQUEST (Klaviyo-Worker nicht erreichbar)",
      "",
      "Product: " + (product.title || "Unknown"),
      "Handle: " + (product.handle || ""),
      "Variant ID: " + (product.variant_id || ""),
      "URL: " + (product.url ? location.origin + product.url : ""),
      "Customer email: " + email
    ].join("\n"));
    const res = await fetch("/contact", { method: "POST", body: fd });
    return res.ok;
  }

  function escapeHtml(str) {
    if (str == null) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
